module.exports = __webpack_public_path__ + "static/media/logo2.ea55dbdf.png";